import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONTROL_UI_ACTION_TYPE = createNamedActions('emailTemplatesControlUI', {
  SET_ACTIVE_TEMPLATE_DATA: 'SET_ACTIVE_TEMPLATE_DATA',
});

// activeTemplateId and activeTemplateCategoryId
export const setActiveTemplateDataAction = templateData => ({
  type: CONTROL_UI_ACTION_TYPE.SET_ACTIVE_TEMPLATE_DATA,
  payload: templateData,
});
